export default __webpack_public_path__ + "static/media/puzzle.ec282de2.svg";